var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2343 25.2844C37.2343 24.398 37.1547 23.5457 37.007 22.7275H25.2343V27.5628H31.9615C31.6718 29.1253 30.7911 30.4491 29.4672 31.3355V34.4719H33.507C35.8706 32.2957 37.2343 29.0912 37.2343 25.2844Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2337 37.5C28.6087 37.5 31.4383 36.3807 33.5065 34.4716L29.4667 31.3352C28.3474 32.0852 26.9155 32.5284 25.2337 32.5284C21.978 32.5284 19.2223 30.3296 18.2394 27.375H14.0632V30.6136C16.1201 34.6989 20.3473 37.5 25.2337 37.5Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2399 27.3749C17.9899 26.6249 17.8479 25.8237 17.8479 24.9999C17.8479 24.176 17.9899 23.3749 18.2399 22.6249V19.3862H14.0638C13.2172 21.0737 12.7343 22.9828 12.7343 24.9999C12.7343 27.0169 13.2172 28.926 14.0638 30.6135L18.2399 27.3749Z",
    fill: "#FBBC05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2337 17.4716C27.0689 17.4716 28.7167 18.1023 30.0121 19.3409L33.5974 15.7557C31.4326 13.7386 28.603 12.5 25.2337 12.5C20.3473 12.5 16.1201 15.3011 14.0632 19.3864L18.2394 22.625C19.2223 19.6705 21.978 17.4716 25.2337 17.4716Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.724bc7f67a031c0905b0dd418c0d144f.svg";
export { ForwardRef as ReactComponent };